import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { AdmissionsAreaService } from '../admissions-area.service';
import { AdmissionsManagerService } from './admissions-manager.service';
import { AdmissionsManagerTab1Part } from './tabs/tab-1/admissions-manager-tab-1.part';
import { AdmissionsManagerTab2Part } from './tabs/tab-2/admissions-manager-tab-2.part';
import { AdmissionsManagerViewsPart } from './views/manager-views.part';


@Component({
	selector: 'admissions-manager-page',
	standalone: true,
	imports: [
		AdmissionsManagerTab1Part, AdmissionsManagerTab2Part, AdmissionsManagerViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './admissions-manager.page.html',
})
export class AdmissionsManagerPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;

	public admissionsService = inject(AdmissionsAreaService);



	constructor(
		public pageService: AdmissionsManagerService,
	) {
	}

	async ngOnInit() {
		await this.admissionsService.loadAdmissionsData();
	}




	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}